import { type Day, TRIGGER_DAYS } from 'apiConnector/scheduledRun/model';
import { ButtonsGroup } from 'components/shared/ButtonsGroup/ButtonsGroup';
import { VerticalFormGroup } from 'components/shared/FormGroup';
import type { IdOwnProps } from 'components/shared/ScheduledRun/type';
import { connect, type MapDispatchToPropsFunction, type MapStateToProps } from 'react-redux';
import { scheduledRunActions } from 'state/scheduledRuns/actions';
import type { ScheduledRunFields } from 'state/scheduledRuns/state';
import type { AppState } from 'state/state.model';

interface StateProps {
  days?: readonly Day[];
}
interface DispatchProps {
  onDaysChanged: (days?: readonly Day[]) => void;
}

interface OwnProps extends IdOwnProps {
  disabled?: boolean;
}
interface Props extends StateProps, DispatchProps, OwnProps {}

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = ({ scheduledRun }, { id }) => ({
  days: scheduledRun.runs[id].days,
});
const mapDispatchToProps: MapDispatchToPropsFunction<DispatchProps, OwnProps> = (dispatch, { id }) => ({
  onDaysChanged(days) {
    dispatch(scheduledRunActions.daysChanged(id, days));
  },
});

export const ConnectedScheduleDays = connect(mapStateToProps, mapDispatchToProps)(ScheduleDays);
function ScheduleDays({ days, onDaysChanged, disabled }: Props) {
  return (
    <>
      <VerticalFormGroup<keyof ScheduledRunFields> label="scheduledRun.days" inputId="days" errorPrefix="">
        <ButtonsGroup
          isDisabled={disabled}
          items={TRIGGER_DAYS}
          selectedItems={days ?? []}
          translationPrefix="scheduledRun.days"
          onSelectionChanged={onDaysChanged}
          allOption="All"
        />
      </VerticalFormGroup>
    </>
  );
}
